<template>
  <div class="flex flex-row">
    <div class="flex-grow"></div>
    <div class="flex flex-row">
      <vue-ads-pagination
        :total-items="total_items"
        :max-visible-pages="number_of_page_links"
        :page="page"
        :items-per-page="9"
        class="flex flex-row"
      >
        <template slot-scope="props">
          <div
            class="hidden sm:hidden md:hidden lg:flex xl:flex text-base self-center italic"
          >
            Taken {{ props.start }} tot {{ props.end }} van de
            {{ props.total }}
          </div>
        </template>

        <template slot="buttons" slot-scope="props">
          <vue-ads-page-button
            v-for="(button, key) in props.buttons"
            :key="key"
            v-bind="button"
            @page-change="pageChange(button.page)"
            class="p-2 hover:text-mi-blue-500 hover:font-extrabold text-base focus:outline-none"
            :disable-styling="true"
            :class="{
              'text-xl': button.active,
              'font-extrabold': button.active,
              'text-mi-blue-500': button.active
            }"
          />
        </template>
      </vue-ads-pagination>
    </div>
    <div class="flex-grow self-center"></div>
  </div>
</template>

<script>
import "../../../node_modules/@fortawesome/fontawesome-free/css/all.css";
import "../../../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css";

import VueAdsPagination, { VueAdsPageButton } from "vue-ads-pagination";

export default {
  name: "Pagination",
  components: {
    VueAdsPagination,
    VueAdsPageButton
  },
  data() {
    return {
      // Narrow screens should have fewer page links
      number_of_page_links: window.innerWidth > 768 ? 5 : 2
    };
  },
  computed: {
    total_items() {
      return this.$store.state.backend_data.todolist_n_search_items;
    },
    page() {
      // backend index starts on 1, component on 0
      return this.$store.state.search.page - 1;
    }
  },
  methods: {
    pageChange(page) {
      this.$store.dispatch("update_search", {
        // backend index starts on 1, component on 0
        selected: page + 1,
        filtername: "page",
        routename: "TodoSearchResults"
      });
    }
  }
};
</script>
